export const ROUTE_CONVERSATION_ID = ":conversationId";

export function routeConversation(): string {
    return "/conversation";
}
